import React from 'react'
import './index.css'

const TYPING_SPEED = 300;
const DELETING_SPEED = 100;

class Typer extends React.Component {

    state = {
        text: '',
        isDeleting: false,
        loopNum: 0,
        typingSpeed: TYPING_SPEED
    }

    componentDidMount() {
        this.handleType();
    }

    handleType = () => {
        const { dataText } = this.props;
        const { isDeleting, loopNum, text, typingSpeed } = this.state;
        const i = loopNum % dataText.length;
        const fullText = dataText[i];

        this.setState({
            text: isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1),
            typingSpeed: isDeleting ? DELETING_SPEED : TYPING_SPEED
        });

        if (!isDeleting && text === fullText) {
            setTimeout(() => this.setState({ isDeleting: true }), 500);
        } else if (isDeleting && text === '') {
            this.setState({
                isDeleting: false,
                loopNum: loopNum + 1
            });
        }

        setTimeout(this.handleType, typingSpeed);
    };

    render() {
        return (
            <h1 className='is-family-code is-size-4'>{this.props.heading}&nbsp;
                <span className='is-family-code btn'>{this.state.text}</span>
                <span id="cursor"></span>
            </h1>
        );
    }
}



export default function Hero(props) {
    return (
        <section id="home" className="hero is-medium is-link">
            <div className='columns'>
                <div className='column'>
                <div className="hero-body">
            <p className='is-size-5 is-family-code'>Hi, My name is</p>
                <p className="title is-size-1 is-family-code">
                    Nikhil Mandge
                </p>
                <p className="subtitle is-size-3 is-family-code">
                    I Build, Test and Deploy things on web.
                </p>
                <p className="subtitle is-size-3 is-family-code">
                    <Typer
                        heading="Using"
                        dataText={[
                            '...React Js',
                            '...Python',
                            '...Java',
                            '...C#',
                            '...AWS',
                            '...Docker',
                            '...GCP',
                            '...RF'

                        ]}
                    />
                </p>
                <p className="subtitle is-size-6 is-family-code">I’m a full-stack software engineer specializing in building web applications.<br />I have completed my M.S. in CS from UNCC (GPA 4.0)<br /> I'm looking forward fulltime opportunities.</p>
                <a href="https://docs.google.com/document/d/1EZpK7-A59QSuGh8XMwFMWGH0lQtTQJMl7MhL0WQMThk/edit?usp=sharing" className='button btn is-family-code'>Download Resume</a>
            </div>
                </div>
                <div className='column'>
                <figure class="image ml-6">
                    <img alt="" class="is-rounded" src="https://i.ibb.co/ysXq2kb/IMG-2248.jpg" />
                </figure>
                </div>
            </div>
        </section>
    )
}
